

import React, { useEffect, useState } from "react";
import styles from "./Product.module.css";
import { useAuth } from "../../components/context/Auth";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import ImageUploder from "../../components/updatedComponents/Product/ImageUploder";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import KeyWordGen from "../../components/updatedComponents/Product/KeyWordGen";
import InputTextArea from "../../components/updatedComponents/Product/InputTextArea";
import InputRedio from "../../components/updatedComponents/FormComponents/InputRedio";
import Button from "../../components/updatedComponents/Dealers/Button";
import { AddTO } from "../../components/icons/Icon3";
import DrawerWrapper from "../../components/updatedComponents/layoutWrapper/DrawerWrapper";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { handleFileData } from "../../APIsControll/apiControl2";
import fetchData from "../../APIsControll/apiControll";
import { validateForAddUpdateProduct } from "../../validation/AddDealer";
import { useNavigate } from "react-router-dom";

const AddProduct = () => {
  const { show } = useToast();
  const { mode } = useAuth();
  const navi = useNavigate();
  const productId = new URLSearchParams(window.location.search).get("productId");
  const [modelContainer, setmodelContainer] = useState(null);
  const [toggle, setToggle] = useState({
    modelToggle: false,
  });
  const [IsLoading, setIsLoading] = useState({
    addProductLoading: false,
  });
  const [fields, setFields] = useState([{
    deliveryMethod: "",
    partnerName: []
  }])
  const [errors, setErrors] = useState({});
  const [id, setid] = useState(null)
  const [url, seturl] = useState("");
  const [SingleData, setSingleData] = useState({
    product_name: "",
    product_id: "",
    type_name: "",
    logo: "",
    metaTitle: "",
    metaKeywords: [],
    focusKeyword: [],
    url: "",
    title: "",
    description: "",
    metaDescription: "",
    status: "",
    dealerOnly: "",
    accessories: "",
    DeskTopBanner: [],
    mobItemBanner: [],
    partneredCompanyProduct: ""
  });

  useEffect(() => {
    const getOneProduct = async () => {
      try {
        const paylod = { _id: productId };
        const res = await fetchData(`content/product`, paylod);
        if (res?.status === "success") {
          setSingleData({
            ...SingleData,
            product_name: res?.data?.itemImgDetails?.product_name
              ? res?.data?.itemImgDetails?.product_name
              : "",
            type_name: res?.data?.product_name ? res?.data?.product_name : "",
            logo: res?.data?.logo ? res?.data?.logo : "",
            DeskTopBanner: res?.data?.banner ? res?.data?.banner : [],
            mobItemBanner: res?.data?.mobBanner ? res?.data?.mobBanner : [],
            title: res?.data?.title ? res?.data?.title : "",
            description: res?.data?.description ? res?.data?.description : "",
            status: res?.data?.status ? res?.data?.status : "",
            dealerOnly: res?.data?.dealerOnly ? res?.data?.dealerOnly : "",
            accessories: res?.data?.accessories ? res?.data?.accessories : "",
            metaTitle: res?.data?.metaTitle ? res?.data?.metaTitle : "",
            metaDescription: res?.data?.metaDescription ? res?.data?.metaDescription : "",
            metaKeywords: res?.data?.metaKeywords ? res?.data?.metaKeywords : [],
            partneredCompanyProduct: res.data.partneredCompanyProduct ? res.data.partneredCompanyProduct : "",
            focusKeyword: res?.data?.focusKeyword ? [res?.data?.focusKeyword] : [],
          });
          seturl(res?.data?.url);
          setid(res?.data?._id ? res?.data?._id : null)
          setFields(res.data.courierName)
        }
      } catch (error) {
      }
    };
    if (productId) {
      getOneProduct();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  // set Meta url
  useEffect(() => {
    const formatUrlFromMetaTitle = (metaTitle) => {
      return metaTitle.replace(/\s+/g, " ").split(" ").join("-").toLowerCase();
    };
    const formattedUrl = formatUrlFromMetaTitle(SingleData.metaTitle);
    seturl(formattedUrl);
  }, [SingleData]);

  // Create DeskTop
  const addNewDeskTopBanner = () => {
    setSingleData((prevData) => ({
      ...prevData,
      DeskTopBanner: [
        ...prevData.DeskTopBanner,
        {
          bannerImg: "",
          itemUrl: "",
          itemUrlType: "",
        },
      ],
    }));
  };

  // Create Mobile
  const addNewMobileBanner = () => {
    setSingleData((prevData) => ({
      ...prevData,
      mobItemBanner: [
        ...prevData.mobItemBanner,
        {
          bannerImg: "",
          itemUrl: "",
          itemUrlType: "",
        },
      ],
    }));
  };

  const HandelRemoveDeskTopBanner = (index) => {
    const updatedList = SingleData.DeskTopBanner.filter((_, i) => i !== index);
    setSingleData({
      ...SingleData,
      DeskTopBanner: updatedList,
    });
  };

  const HandelRemoveMobItemBanner = (index) => {
    const updatedList = SingleData.mobItemBanner.filter((_, i) => i !== index);
    setSingleData({
      ...SingleData,
      mobItemBanner: updatedList,
    });
  };

  // set Desktop and Mobile Image
  const handleImageChange = (bannerType, index, imageUrl) => {
    const updatedBanner = [...SingleData[bannerType]];
    updatedBanner[index].bannerImg = imageUrl;
    setSingleData({
      ...SingleData,
      [bannerType]: updatedBanner,
    });
  };

  // add and update
  const NewPrductCreate = async () => {
    try {
      const validationErrors = validateForAddUpdateProduct(SingleData);
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
      setIsLoading({ ...IsLoading, addProductLoading: true });
      const formdata = new FormData();
      formdata.append("product_name", SingleData.type_name);
      formdata.append("logo", SingleData.logo);
      formdata.append("metaTitle", SingleData.metaTitle);
      formdata.append("url", url);
      formdata.append("title", SingleData.title);
      formdata.append("description", SingleData.description);
      formdata.append("metaKeywords", JSON.stringify(SingleData.metaKeywords));
      formdata.append("focusKeyword", SingleData.focusKeyword[0] ? SingleData.focusKeyword[0] : "");
      formdata.append("metaDescription", SingleData.metaDescription);
      formdata.append("status", SingleData.status);
      formdata.append("cartType", SingleData.type_name);
      formdata.append("dealerOnly", SingleData.dealerOnly);
      formdata.append("accessories", SingleData.accessories);
      formdata.append("partneredCompanyProduct", SingleData.partneredCompanyProduct);
      formdata.append("courierName", JSON.stringify(fields));

      SingleData.DeskTopBanner.forEach((item) => {
        formdata.append("bannerImg", item.bannerImg);
        formdata.append("itemUrl", item.itemUrl);
        formdata.append("itemUrlType", item.itemUrlType);
      });

      SingleData.mobItemBanner.forEach((item) => {
        formdata.append("mobBannerImg", item.bannerImg);
        formdata.append("mobItemUrl", item.itemUrl);
        formdata.append("mobItemUrlType", item.itemUrlType);
      });

      formdata.append("bannerUpdate", "");
      formdata.append("mobBannerUpdate", "");
      id && formdata.append("_id", id);
      const res = await handleFileData("content/addUpdateProduct", formdata);
      if (res.status === "success") {
        show(res.msg || res.message || res.data, "success");
        navi(-1)
        return;
      }
      if (res.status === "failed") {
        show(res.msg || res.message, "error");
        return;
      } else {
        show("Error", "error");
      }
    } catch (error) {
      show("Error", "error");
    } finally {
      setIsLoading({ ...IsLoading, addProductLoading: false });
    }
  };

  return (
    <div className={styles.Main_Layout}>
      <DrawerWrapper
        isOpen={toggle.modelToggle}
        onClose={() => setToggle({ ...toggle, modelToggle: false })}
      >
        {modelContainer}
      </DrawerWrapper>

      <div
        className={styles.Layout}
        style={{
          backgroundColor: mode ? "#2B2D31" : "#F8F9FC",
          color: mode
            ? "#fff"
            : "#000" /* cursor: disabled ? "not-allowed" : "" */,
        }}
      >
        {/* <form> */}
        <div className={styles.Top_bar_css}>
          <div className={styles.gobackClass}>
            <TopTabBar text={`Product`} />
          </div>
          <div className={styles.btn_Continer}>
            <div style={{ width: "120px" }}>
              <Button
                buttonText={productId ? "Update" : "Create"}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#fff"}
                buttonIcon={<AddTO />}
                disabledButtonTextColor={"#fff"}
                disabledButtonBgColor={"#4164E3"}
                buttonClick={NewPrductCreate}
                loading={IsLoading.addProductLoading}
              />
            </div>
          </div>
        </div>

        <div className={styles.form_continer}>
          {/* col - 1 */}
          <div className={styles.Col_sm}>
            <InputTag
              labelText={"Meta URL"}
              star={true}
              padding={"8px"}
              fontSize={"12px"}
              maxLength={10000}
              placeholderType={"text"}
              required={true}
              value={url}
              // disabled={true}
              onChange={(e) => seturl(e.target.value)}
              errorText={errors.url}

            />
            <InputTag
              labelText={"Product Name"}
              star={true}
              padding={"8px"}
              fontSize={"12px"}
              maxLength={10000}
              placeholderType={"text"}
              value={SingleData?.type_name}
              onChange={(e) =>
                setSingleData({ ...SingleData, type_name: e.target.value })
              }
              warning={errors.type_name}
            />
            <div
              className={styles.Col_sm_sub4}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div
                className={styles.text_color}
                style={{ color: mode ? "#fff" : "#647298" }}
              >
                {" "}
                <span>Logo </span>{" "}
              </div>{" "}
              <div></div>
              <div>
                <ImageUploder
                  image={SingleData.logo}
                  setimage={(imge) =>
                    setSingleData({ ...SingleData, logo: imge })
                  }
                  selectText={"Select Master Image"}
                  error={errors.logo}
                />
              </div>
            </div>
            <div
              className={styles.Col_sm_sub4}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div
                className={styles.text_color}
                style={{ color: mode ? "#fff" : "#647298" }}
              >
                {" "}
                <span>Desktop Banner </span>{" "}
              </div>{" "}
              <div></div>
              {SingleData?.DeskTopBanner?.map((item, index) => (
                <div key={`Dexttop-${index}`}>
                  <div>
                    <ImageUploder
                      image={item.bannerImg}
                      setimage={(imageUrl) =>
                        handleImageChange("DeskTopBanner", index, imageUrl)
                      }
                      options={[
                        { label: "ITEM", value: "item" },
                        { label: "URL", value: "Url" },
                        { label: "N/A", value: "N/A" },
                      ]}
                      value={item.itemUrlType}
                      setoption={(selectedOption) => {
                        const updatedDeskTopBanner = [
                          ...SingleData.DeskTopBanner,
                        ];
                        updatedDeskTopBanner[index].itemUrlType =
                          selectedOption.value;
                        setSingleData({
                          ...SingleData,
                          DeskTopBanner: updatedDeskTopBanner,
                        });
                      }}
                      handeremove={() => HandelRemoveDeskTopBanner(index)}
                      selectText={"Select Master Image"}
                    />
                  </div>
                  <div>
                    <InputTag
                      padding={"8px"}
                      fontSize={"12px"}
                      maxLength={10000}
                      placeholderType={"text"}
                      placeholderText="URL.."
                      value={item.itemUrl}
                      onChange={(e) => {
                        const updatedDeskTopItemUrl = [
                          ...SingleData.DeskTopBanner,
                        ];
                        updatedDeskTopItemUrl[index].itemUrl = e.target.value;
                        setSingleData({
                          ...SingleData,
                          DeskTopBanner: updatedDeskTopItemUrl,
                        });
                      }}
                    />
                  </div>
                </div>
              ))}
              <div style={{ width: "120px", height: "auto" }}>
                <Button
                  buttonText={"ADD"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#fff"}
                  buttonIcon={<AddTO />}
                  // disabled={disabled}
                  disabledButtonTextColor={"#fff"}
                  disabledButtonBgColor={"#4164E3"}
                  buttonClick={addNewDeskTopBanner}
                />
              </div>
            </div>
            <div
              className={styles.Col_sm_sub4}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div
                className={styles.text_color}
                style={{ color: mode ? "#fff" : "#647298" }}
              >
                {" "}
                <span> Mobile Banner </span>{" "}
              </div>{" "}
              <div></div>
              {SingleData?.mobItemBanner?.map((item, index) => (
                <div key={`mobItem-${index}`}>
                  <div>
                    <ImageUploder
                      image={item.bannerImg}
                      setimage={(imageUrl) =>
                        handleImageChange("mobItemBanner", index, imageUrl)
                      }
                      options={[
                        { label: "ITEM", value: "item" },
                        { label: "URL", value: "Url" },
                        { label: "N/A", value: "N/A" },
                      ]}
                      selectText={"Select Master Image"}
                      value={item.itemUrlType}
                      setoption={(selectedOption) => {
                        const updatedDeskTopBanner = [
                          ...SingleData.mobItemBanner,
                        ];
                        updatedDeskTopBanner[index].itemUrlType =
                          selectedOption.value;
                        setSingleData({
                          ...SingleData,
                          mobItemBanner: updatedDeskTopBanner,
                        });
                      }}
                      handeremove={() => HandelRemoveMobItemBanner(index)}
                    />
                  </div>
                  <div>
                    <InputTag
                      padding={"8px"}
                      fontSize={"12px"}
                      maxLength={10000}
                      placeholderType={"text"}
                      placeholderText="URL.."
                      value={item.itemUrl}
                      onChange={(e) => {
                        const updatedDeskTopItemUrl = [
                          ...SingleData.mobItemBanner,
                        ];
                        updatedDeskTopItemUrl[index].itemUrl = e.target.value;
                        setSingleData({
                          ...SingleData,
                          mobItemBanner: updatedDeskTopItemUrl,
                        });
                      }}
                    />
                  </div>
                </div>
              ))}
              <div style={{ width: "120px", height: "auto" }}>
                <Button
                  buttonText={"ADD"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#fff"}
                  buttonIcon={<AddTO />}
                  disabledButtonTextColor={"#fff"}
                  disabledButtonBgColor={"#4164E3"}
                  buttonClick={addNewMobileBanner}
                />
              </div>
            </div>
          </div>

          {/* col - 2 */}
          <div
            className={styles.Col_sm1}
            style={{
              backgroundColor: mode ? "#232529" : "#fff",
              color: mode ? "#fff" : "#000",
            }}
          >
            <div>
              <InputTag
                labelText={"Product Title"}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                star={true}
                value={SingleData.title}
                onChange={(e) =>
                  setSingleData({ ...SingleData, title: e.target.value })
                }
                warning={errors.title}
              />
            </div>
            <div>
              <InputTextArea
                lableText={"Product Description (Optional)"}
                value={SingleData.description}
                onChange={(e) =>
                  setSingleData({ ...SingleData, description: e.target.value })
                }
              />
            </div>
            <div className={styles.Redio_type_btn_con}>
              <div>
                Status<span style={{ color: "red" }}>*</span>{" "}
              </div>
              <div className={styles.redio_btn_div}>
                <div>
                  <InputRedio
                    lableText={"Yes"}
                    name={"OnlineVisible"}
                    checked={SingleData?.status === "Active"}
                    onChange={() =>
                      setSingleData({ ...SingleData, status: "Active" })
                    }
                  // disabled={disabled}
                  />
                </div>
                <div>
                  <InputRedio
                    lableText={"No"}
                    name={"OnlineVisible"}
                    checked={SingleData?.status === "Disable"}
                    onChange={() =>
                      setSingleData({ ...SingleData, status: "Disable" })
                    }
                  // disabled={disabled}
                  />
                </div>
              </div>
            </div>
            <div className={styles.Redio_type_btn_con}>
              <div>
                Dealer Only<span style={{ color: "red" }}>*</span>{" "}
              </div>
              <div className={styles.redio_btn_div}>
                <div>
                  <InputRedio
                    lableText={"Yes"}
                    name={"dealerOnly"}
                    checked={SingleData?.dealerOnly === "Active"}
                    onChange={() =>
                      setSingleData({ ...SingleData, dealerOnly: "Active" })
                    }
                  // disabled={disabled}
                  />
                </div>
                <div>
                  <InputRedio
                    lableText={"No"}
                    name={"dealerOnly"}
                    checked={SingleData?.dealerOnly === "Disable"}
                    onChange={() =>
                      setSingleData({ ...SingleData, dealerOnly: "Disable" })
                    }
                  // disabled={disabled}
                  />
                </div>
              </div>
            </div>

          </div>
          {/* col - 3 */}
          <div
            className={styles.Col_sm2}
            style={{
              backgroundColor: mode ? "#232529" : "#fff",
              color: mode ? "#fff" : "#000",
            }}
          >
            <div>
              <InputTag
                labelText={"Meta Title"}
                star={true}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                value={SingleData.metaTitle}
                onChange={(e) =>
                  setSingleData({ ...SingleData, metaTitle: e.target.value })
                }
                warning={errors.metaTitle}
              />
            </div>
            <div>
              <InputTextArea
                lableText={"Meta Description (Optional)"}
                value={SingleData.metaDescription}
                onChange={(e) =>
                  setSingleData({
                    ...SingleData,
                    metaDescription: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <KeyWordGen
                lableText={"Keywords"}
                // star={true}
                words={SingleData.metaKeywords}
                setWords={(e) =>
                  setSingleData({ ...SingleData, metaKeywords: e })
                }
              />
            </div>
            <div>
              <KeyWordGen
                lableText={"Focus Keywords"}
                maxLength={1}
                words={SingleData.focusKeyword}
                setWords={(e) =>
                  setSingleData({ ...SingleData, focusKeyword: e })
                }
              />
            </div>
          </div>
        </div>

        {/* </form> */}
      </div>
    </div>
  );
};

export default AddProduct;
